(function (angular) {
    'use strict';

    angular.module('app.landing').controller('app.landing.welcomeController', ['$http', '$scope', welcomeController]);

    function welcomeController($http, $scope) {
        $scope.siteContent = siteContent;

        var vm = this;
        vm.plans = siteContent.planOptions;

        // Private properties
        var memberQuoteClassName = 'member-quote';
        var activeClassName = 'active';
        var quoteRotationInterval = 12000; // in miliseconds
        var memberQuotes = [];

        onInit();

        function onInit() {
            memberQuotes = document.getElementsByClassName(memberQuoteClassName);
            rotateQuotes();
        }

        function rotateQuotes() {
            var counter = 0;
            var prev = counter - 1;

            // Infinite loop
            setInterval(function changeQuoteLoop() {
                if (memberQuotes.length === 0) {
                    return;
                }

                // Hide previously shown item
                if (prev > -1) {
                    memberQuotes[prev].classList.remove(activeClassName);
                }

                // Show the next item
                memberQuotes[counter].classList.add(activeClassName);

                counter = counter + 1;
                prev = counter - 1;

                // Reset
                if (counter === memberQuotes.length) {
                    counter = 0;
                }
            }, quoteRotationInterval);
        }
    }
})(angular);
